/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Filter_Status1Inputs */

const vi_cmspost_filter_status1 = /** @type {(inputs: Cmspost_Filter_Status1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trạng thái`)
};

/**

* @param {Cmspost_Filter_Status1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_filter_status1 = /** @type {((inputs?: Cmspost_Filter_Status1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Filter_Status1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_filter_status1(inputs)
});
export { cmspost_filter_status1 as "cmsPost_filter_status" }